export const Colors = {
  PRIMARY_COLOR: '#191937',
  ACCENT_COLOR: '#ff0055',
  SUCCESS_COLOR: '#84F542'
}
